<template>
	<div id="app">
		<div class="pinContainer" ref="pin">
      <start-screen />
		</div>

		<!--<section class="pinIndicatorBlock">-->
			<!--<div class="indicator">-->
			<!--</div>-->
    <!--</section>-->
  <div class="real-bryansk real-bryansk_default">Реализация в&nbsp;Брянской&nbsp;области</div> 
  <section class="pinContainer2 grid-block" ref="pin2"> <h1 class="grid-block__header">Фотофакты</h1>
			<div style="" v-for="(item, index) in indicators">
        <template v-if="item.cite">
          <div :class="'trigger' + index"/>
          <cite-block :id="'cite' + index" :text="item.cite.text" :description="item.cite.description"/>
        </template>
        <indicator v-if="phone || true ||  slide>index" :image="'url('+ item.image +')'">
          <div slot="digit">
            <div v-html="formatIndicators(item.end, item.postfix)"></div> 
            <!--<counter-up :start="item.start" :end="item.end" :duration="item.duration" :decimals="item.decimals" :postfix="item.postfix" key="`indicators-${index}`" @count-completed="completed"/>-->
          </div>
					<div v-html="item.description"></div>
				</indicator>
				<br/>
			</div>
		</section>
    <section class="grid-block ">
      <h1 class="grid-block__header">Карта фактов</h1>
      <div class="map__description" v-if="multiTouch">
        <div class="grid__cell">
          <div class="global_center"><img src="./assets/2-fingers.svg"/></div>
          <div class="global_center">Для сдвига карты вправо-влево, вверх-вниз проведите двумя пальцами</div>
        </div>
        <div class="grid__cell">
          <div class="global_center"><img  src="./assets/2-fingers-resize.svg"/></div>
          <div class="global_center">Для изменения масштаба карты</div>
        </div>
      </div>
      <my-map class="grid-block__map_default" v-if="slide>1"/>
    </section>
	</div>
</template>

<script>
import CounterUp from './components/CounterUp.vue'
import MyMap from './components/MyMap.vue'
import Indicator from './components/Indicator.vue'
import CiteBlock from './components/CiteBlock.vue'
import StartScreen from './components/StartScreen.vue'
import isMobile from 'ismobilejs'
import Utils from './Utils.js'
import indicatorsData from './indicators.js'
export default {
  name: 'app',
  mounted () {
    if (isMobile.phone || Utils.getDocumentWidth() < 768) {
     // this.$nextTick(this.pinContainerScene2)
      this.slide = 2
      this.$nextTick(this.mobileAnimation)
    } else {
      this.$nextTick(this.pinContainerScene2)
    }
  },
  data () {
    return {
      indicators: indicatorsData,
      multiTouch: isMobile.phone || isMobile.tablet,
      phone: isMobile.phone,
      tablet: isMobile.tablet,
      startCount: false,
      slide: 1
    }
  },
  components: {
    CounterUp, MyMap, Indicator, CiteBlock, StartScreen
  },
  methods: {
    formatIndicators: function (value, postfix) {
      let val = (value).toFixed(0).replace('.', ',')
      let fval = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
      return fval + ' ' + postfix
    },
    completed: function () {
      // console.log('completed')
      this.slide ++
    },
    startAnimation: function () {
      this.startCount = !this.startCount
    },
    initHandler: function () {
    },
    checkCite: function (index) {
      return (index % 3) === 0
    },
    addScene: function () {
      // console.dir(arguments)
    },
    mobileAnimation () {
      console.log('mobile animation')
    },
    pinContainerScene2 () {
      const tl = new this.$gsap.TimelineMax()
      const duration = 2
      tl.add('first', 0)
      tl.add('real', 1)
      tl.add('second', duration)
      tl.to('.start-screen__coverage', duration, {css: {className: 'start-screen__coverage_full start-screen__coverage'}})
      tl.from('.start-screen__strip_left', duration, {right: '0%', bottom: '0%', transform: 'rotateZ(0deg)'}, 'first')
      tl.from('.start-screen__strip_top', duration, {left: '100%', bottom: '0%', transform: 'rotateZ(0deg)', opacity: 1}, 'first')
      tl.from('.start-screen__strip_right', duration, {left: '100%', top: '100%', transform: 'rotateZ(0deg)', opacity: 1}, 'first')
      tl.from('.start-screen__strip_bottom', duration, {right: '0%', top: '100%', transform: 'rotateZ(0deg)', opacity: 1}, 'first')
      tl.from('.real-bryansk_default', duration, {opacity: 0}, 'real')
      // tl.to('div.standart', duration, {left: '0%', transform: 'scale(0.5,0.5)'}, 'first')
      tl.to(
        'div.start-screen__coverage',
        duration,
        {
          left: '0',
          top: '0',
          width: '25%',
          height: '20%',
          onComplete: function () {
            this.slide = 2
          },
          onCompleteScope: this
        },
        'first'
      )
      tl.to(
          'div.start-screen__main-title',
          duration,
        {
          css: {
            className: 'start-screen__main-title start-screen__main-title_left'
          }
        },
        'first'
      )
      tl.to(
          '.start-screen__standart',
          duration,
        {
          css: {
            className: 'start-screen__standart  start-screen__standart_left'
          }
        },
        'first'
      )
      /*
      tl.from(
        '.cite-block',
        duration,
        {
          top: '200%',
          ease: this.$gsap.Circ.easeOut
        }
      )
    */
    // create scene and set its params
      const scene = new this.$scrollmagic.Scene({
        triggerElement: '.pinContainer',
        triggerHook: 'onLeave',
        duration: `50%`
      })
      .setPin('.pinContainer')
      .setTween(tl)

    // Add scene to ScrollMagic controller by emiting an 'addScene' event on vm.$ksvuescr (which is our global event bus)
      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene)

      const tl0 = new this.$gsap.TimelineMax()

      const scene0 = new this.$scrollmagic.Scene({
        triggerElement: '.trigger0',
        triggerHook: 0.9,
        duration: '300'
      })
      .setTween(tl0)

      tl0.from(
        '#cite0',
        2,
        {
          top: '101%'
        }
      )
      tl0.to(
        '.real-bryansk_default',
        1,
        {
          display: 'none'
        }
      )
      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene0)
      var keys = []
      indicatorsData.forEach((element, index) => {
        if (element.cite && index > 0) {
          keys.push(index)
        }
      })

      var tln = []
      var scenen = []
      var prev = 0
      keys.forEach((element) => {
        tln[element] = new this.$gsap.TimelineMax()
        tln[element].add('first', 0)
        scenen[element] = new this.$scrollmagic.Scene({
          triggerElement: '.trigger' + element,
          triggerHook: 0.9,
          duration: '300'
        }).setTween(tln[element])
        tln[element].to(
          '#cite' + prev,
          2,
          {
            left: '-40%'
          },
          'first'
        )
        tln[element].from(
          '#cite' + element,
          2,
          {
            top: '101%'
          },
          'first'
        )
      // for rounded digits
       /* tln[element].to(
          this,
          2,
          {slide: element},
          'first'
        ) */
        prev = element
        this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scenen[element])
      }
      )
/*
      const tl3 = new this.$gsap.TimelineMax()
      tl3.add('first', 0)

      const scene3 = new this.$scrollmagic.Scene({
        triggerElement: '.trigger3',
        triggerHook: 0.9,
        duration: '300'
      })
      .setTween(tl3)

      tl3.to(
        '#cite0',
        2,
        {
          left: '-40%'
        },
        'first'
      )
      tl3.from(

        '#cite3',
        2,
        {
          top: '101%'
        },
        'first'
      )

      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene3)

      const tl7 = new this.$gsap.TimelineMax()
      tl7.add('first', 0)

      const scene7 = new this.$scrollmagic.Scene({
        triggerElement: '.trigger7',
        triggerHook: 0.9,
        duration: '300'
      })
      .setTween(tl7)

      tl7.to(
        '#cite3',
        2,
        {
          left: '-40%'
        },
        'first'
      )
      tl7.from(
        '#cite7',
        2,
        {
          top: '101%'
        },
        'first'
      )
      this.$ksvuescr.$emit('addScene', 'pinContainerScene2', scene7)
      */
    },
    destroyed () {
    // Destroy ScrollMagic when our component is removed from DOM
      this.$ksvuescr.$emit('destroy')
    }
  }
}
</script>

<style>
@import './style.css'; 
@use saladcss-bem;
@use lost;

.grid-block__header {
  font-weight:bolder;
  font-family: Impact, Arial, Helvetica, sans-serif; 
  font-size: 3rem;
  color: #163f5f;
}
.grid-block {
}
.grid-block__map_default {
  width: 100%;
  height:100vh;
}

.skew-wrapper_default {
  width:20%;
  height:60vh;
  left:5%;
	transform: skew(-30deg,0deg);
  top:30%;
  z-index:120;
  position:fixed;
	background-color: red;
}

.real-bryansk_default {
  position: absolute;
  left: 0%;
  top: 85%;
  width:100%;
  text-align: center;
  font-family: Arial;
  font-size: 1.5rem;
  color: white;
  z-index:100;
}

.grid__cell {
  padding-top:15px;
  margin-top:15px;
  margin-bottom: 15px;
  lost-column:1/1;
  background-color:white;
}
.map__description{
  margin:5px;
  lost-utility: clearfix;
} 

body {
  background-color:#ececed;
}






/*.images img{
    max-height:200px;
    }
*/    
.ribbon {
  width:90%;
  padding-left:60px;
  padding-right:60px;  margin-right:90%;
  margin-right:90
}
.pinContainer {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  position: relative;
}

.pinIndicatorBlock {
/*  width: 70%;
  right: 100%;
  border: 2px solid;
  margin-left: 30%;
*/  
}

.panel{
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left:0;
  /*display: flex;
  justify-content: center;
  align-items: center;*/
  color: white;
  font-size: 3rem;
}

.main-screen::after {
  content: "";
  left: 0;
  bottom: 0;
  border-top: solid 100px transparent;
  border-right: solid 0 transparent;
  border-bottom: solid 100px #151515;
  border-left: solid 50vw #151515;
}

body{
  margin:0;
  padding:0;
 overflow-x:hidden;
}
/*.main-title{
  left:20%;
  top:20%;
  width:60%;
  font-size:4rem;
  margin-left:auto;
  margin-right:auto;
  position:absolute;
  z-index: 200;
  color: white;
  position: fixed;
}
*/
@media (--ss) {
  .grid__cell {
    padding-top:15px;
    margin-top:15px;
    margin-bottom: 15px;
    lost-column:1/2;
    background-color:white;
    min-height:150px;
  }
}

@media (--ms) {
  .grid-block {
    margin-left:30%;
    width:70%;
  }
  .real-bryansk_default {
    position: fixed;
    left: 58%;
    top: 70%;
    width: 40%;
    text-align: left;
    font-size: 2rem;
    opacity: 1;
    font-weight:bolder;
    font-family:Arial;
    color: white;
    margin:0;
    padding:0;
    background:transparent;
    text-shadow:2px 2px 1px #999;
    z-index: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue